import React, { Key, useContext, useState, useEffect } from "react";
import {
    checkForOverlappingSlots,
    toggleAddMoreSlotBtn,
} from "@ts/day-parting";
import { mainContext } from "@ts/constants";
import $ from "jquery";
import { useSelector } from "react-redux";
import {
    IMainContext,
    TDaypartingDataObject,
    TIsDaypartingEdit,
} from "@ts/common-types";
interface ITimeComponent {
    cardId: string;
    timeArr: string[];
    timeType: string;
    canManageDayParting: boolean
}

const DayPartingTimeComponent: React.FC<ITimeComponent> = ({
    cardId,
    timeArr,
    timeType,
    canManageDayParting
}) => {
    const { dprTimeSlots, setDprTimeSlots, daypartingCardCheckedData } =
        useContext<IMainContext>(mainContext);
    const isDaypartingEdit = useSelector(
        (state: TIsDaypartingEdit) => state.isDaypartingEdit.value
    );
    const [selected, setSelected] = useState("");
    const daypartingDataObject = useSelector(
        (state: TDaypartingDataObject) => state.daypartingDataObject.value
    );
    const key = cardId.split("-").pop();
    const cardKey = `slot-${key}`;
    const currentCardDay = cardId.split("-").shift();
    const start = $(`#${currentCardDay}-start-time-${key}`).val();
    const end = $(`#${currentCardDay}-end-time-${key}`).val();

    useEffect(() => {
        let currentTimeValue = "";
        let currentAllDaysValue = false;
        if (
            // dprTimeSlots[currentCardDay].hasOwnProperty(cardKey) &&
            // dprTimeSlots[currentCardDay][cardKey].hasOwnProperty([timeType])
            Object.prototype.hasOwnProperty.call(dprTimeSlots[currentCardDay], cardKey) &&
            Object.prototype.hasOwnProperty.call(dprTimeSlots[currentCardDay][cardKey], timeType)
        ) {
            currentTimeValue = dprTimeSlots[currentCardDay][cardKey][timeType];
        }
        // daypartingCardCheckedData[currentCardDay].hasOwnProperty(cardKey)
        if (Object.prototype.hasOwnProperty.call(daypartingCardCheckedData[currentCardDay], cardKey)) {
            currentAllDaysValue =
                daypartingCardCheckedData[currentCardDay][cardKey];
        }
        $(`#${cardId}`).val(currentTimeValue);
        $(`#${currentCardDay}-all-days-${key}`).prop(
            "checked",
            currentAllDaysValue
        );

        if ($(`#${currentCardDay}-all-days-${key}`).is(":checked")) {
            $(`#${currentCardDay}-all-days-${key}`).prop("disabled", false);
        } else {
            if (start && end) {
                $(`#${currentCardDay}-all-days-${key}`).prop("disabled", false);
            } else {
                $(`#${currentCardDay}-all-days-${key}`).prop("disabled", true);
            }
        }

        toggleAddMoreSlotBtn(currentCardDay, dprTimeSlots);

        if (isDaypartingEdit) {
            if (dprTimeSlots[currentCardDay].state) {
                $(`#toggle-${currentCardDay}-dpr`).prop(
                    "checked",
                    dprTimeSlots[currentCardDay].state
                );
            } else {
                $(`#toggle-${currentCardDay}-dpr`).prop("checked", false);
            }

            if (
                Object.values(dprTimeSlots).filter(
                    (rules: Record<string, boolean | string>) => rules.state
                ).length === 7
            ) {
                $("#toggle-all-dpr").prop("checked", true);
            } else {
                $("#toggle-all-dpr").prop("checked", false);
            }
        }

        setSelected(currentTimeValue);
        if (!cardId.split("-").includes("end")) {
            if (
                dprTimeSlots[currentCardDay][cardKey] &&
                Object.prototype.hasOwnProperty.call(dprTimeSlots[currentCardDay][cardKey], "start")
                // dprTimeSlots[currentCardDay][cardKey].hasOwnProperty("start")
            ) {
                $(`#${currentCardDay}-end-time-${key}`).prop("disabled", false);
            }
        }
        // eslint-disable-next-line
    }, [daypartingDataObject, dprTimeSlots, isDaypartingEdit, currentCardDay]);


    return (
        <div className="day-parting-time-container">
            <select
                className="text-center"
                id={cardId}
                style={{ width: "100%", border: "1px solid gray" }}
                value={selected}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    checkForOverlappingSlots(
                        cardId,
                        e.target.value,
                        dprTimeSlots,
                        setSelected,
                        setDprTimeSlots
                    );
                }}
            >
                <option value={undefined} disabled selected></option>
                {timeArr.map((time: string, index: Key) => {
                    return (
                        <option value={time} key={index}>
                            {time}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default DayPartingTimeComponent;
